import React, { useState } from "react";
import {
  Input,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import { ApiResponse } from "model/response";
import './index.css';

interface EditbaleInputProps {
  index: string;
  id?: number;
  updateKey: string;
  updateValue: string;
}

interface UpdateData<T> {
  [Key: string]: T
}

export default function EditbaleInput({ index, id, updateKey, updateValue }: EditbaleInputProps) {
  const [isEdit, setIsEdit] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [data, setData] = useState(updateValue);

  const handleInputChange = (e: any) => {
    setData(e.target.value);
    setIsChange(true);
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {isEdit ? (
        <Input
          type={"textarea"}
          style={{ minWidth: 300 }}
          value={data}
          onChange={(e) => handleInputChange(e)}
        />
      ) : (
        <span
          onDoubleClick={() => {
            setIsEdit(true);
          }}
        >
          {data}
        </span>
      )}
      <span
        className="editable-input__edit-button"
        onClick={async () => {
          if (isEdit) {
            if (isChange) {
              let url = `${index}/${id}`;
              let requestData: UpdateData<string> = {};
              requestData[updateKey] = data;
              const res: ApiResponse = await ApiCaller.put(url, requestData);
              if (res?.status === "ok") {
                setIsEdit(false);
              }
            } else {
              setIsEdit(false);
            }
          } else {
            setIsEdit(true);
          }
        }}
      >
        {isEdit ?
          <span className="material-icons">done</span>
          :
          <span className="material-icons">edit</span>
        }
      </span>
      {isEdit &&
        <span
          className="editable-input__edit-button"
          onClick={async () => setIsEdit(false)}
        >
          <span className="material-icons">cancel</span>
        </span>
      }
    </div>
  );
}
